import DeviceManager from '../utils/device-manager';
import $ from "jquery";

class ReferenceSlider {
	constructor($el) {
		this.$el = $el;

		this.options = {
            optionMobile: {
                direction: 'horizontal',
                loop: true,
                freeMode: false,
                slidesPerView: 2,
                spaceBetween: 30,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: true,
                },
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                    dragSize: 80,
                }
            },
            optionsTablet: {
                direction: 'horizontal',
                loop: true,
                freeMode: false,
                spaceBetween: 36,
                slidesPerView: 3,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: true,
                },
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                    dragSize: 80,
                }
            },
            optionsDesktop: {
                direction: 'horizontal',
                loop: true,
                freeMode: false,
                spaceBetween: 36,
                slidesPerView: 5,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: true,
                },
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                    dragSize: 336,
                }
            }
            
		};

		if (this.$el.length) {
			this._init();
            this._bindEvents();
		}
	}

    _init() {
        this.$slides = this.$el.find('.reference-slider__item');
        this.slidesCount = this.$slides.length;

        // console.log(this.slidesCount);

        if (document.body.clientWidth < 768 && this.slidesCount > 1) {
            this.slider = new Swiper(this.$el[0], this.options.optionMobile);
        } else if (document.body.clientWidth > 767 && this.slidesCount > 2) {
            this.slider = new Swiper(this.$el[0], this.options.optionsTablet);
        } else if (document.body.clientWidth > 1199 && this.slidesCount > 3) {
            this.slider = new Swiper(this.$el[0], this.options.optionsDesktop);
        } else {
            this._destroy();
        }

        // this.slider = new Swiper(this.$el[0], this.options);

        // if (document.body.clientWidth < 1200) {
        //     console.log('slider des références');
        // } else {
        //     console.log('NO slider des références');
        // } 
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
    }

    _destroy() {
        if(this.slider) {
            this.slider.destroy(true,true);
            this.slider = null;
        }
    }

    _onBreakpointChange() {
        if (document.body.clientWidth < 1200) {
            this._destroy();
            this.slider = new Swiper(this.$el[0], this.options);
            console.log('Slider des références - RESIZE');

        } else {
            this._destroy();
            console.log('NO slider des références - RESIZE');
        }
    }

}

export default ReferenceSlider;
